'use client';

import React from 'react';
import Link from 'next/link';
import { generateBreadcrumbSchema } from '@/lib/structuredData';
import { SITE_CONFIG } from '@/lib/seoConfig';

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    ...items,
  ];

  const schemaItems = breadcrumbItems.map((item) => ({
    name: item.label,
    url: `${SITE_CONFIG.url}${item.href}`,
  }));

  const breadcrumbSchema = generateBreadcrumbSchema(schemaItems);

  return (
    <>
      <nav className="bg-background border-b border-border" aria-label="Breadcrumb">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3">
          <ol className="flex items-center gap-2 text-sm text-text-muted overflow-x-auto whitespace-nowrap">
            {breadcrumbItems.map((item, index) => (
              <li key={item.href} className="flex items-center gap-2">
                {index > 0 && (
                  <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                )}
                {index === breadcrumbItems.length - 1 ? (
                  <span className="text-text-primary font-medium">{item.label}</span>
                ) : (
                  <Link href={item.href} className="hover:text-brand-blue transition-colors">
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>

      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}
